import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import SvgIcon from '@material-ui/core/SvgIcon';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Title from '@afosto/components-react/Title';

const DrawerContainer = styled(({ drawerWidth, ...props }) => <Drawer {...props} />)`
  && {
    .MuiDrawer-paper {
      overflow-y: initial;
      max-width: calc(100% - 56px);
      ${props => (props.drawerWidth ? `width: ${props.drawerWidth};` : null)}
    }
  }
`;

const ContentDrawerHeader = styled.div`
  padding-top: ${props => props.theme.spacing()}px;
  padding-bottom: ${props => props.theme.spacing(3)}px;
`;

const DrawerContentContainer = styled.div`
  overflow-y: auto;
  min-height: 100%;
  padding: ${props => props.theme.spacing(2)}px;
`;

const CloseDrawerButton = styled(IconButton)`
  && {
    color: #fff;
    position: absolute;
    top: 14px;
    left: -50px;
  }
`;

const ContentDrawer = ({
  anchor,
  title,
  isOpen,
  showCloseButton,
  handleClose,
  drawerWidth,
  children,
  ModalProps,
}) => (
  <DrawerContainer
    anchor={anchor}
    open={isOpen}
    onClose={handleClose}
    drawerWidth={drawerWidth}
    ModalProps={ModalProps}
  >
    {showCloseButton && (
      <CloseDrawerButton onClick={handleClose}>
        <SvgIcon>
          <FontAwesomeIcon icon={['fal', 'times-circle']} />
        </SvgIcon>
      </CloseDrawerButton>
    )}
    <DrawerContentContainer>
      <ContentDrawerHeader>{title && <Title title={title} />}</ContentDrawerHeader>
      {children}
    </DrawerContentContainer>
  </DrawerContainer>
);

ContentDrawer.propTypes = {
  anchor: PropTypes.string,
  title: PropTypes.any,
  isOpen: PropTypes.bool,
  drawerWidth: PropTypes.string,
  showCloseButton: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.node,
  ModalProps: PropTypes.object,
};

ContentDrawer.defaultProps = {
  anchor: 'right',
  title: undefined,
  drawerWidth: null,
  isOpen: false,
  showCloseButton: true,
  handleClose: undefined,
  children: undefined,
  ModalProps: undefined,
};

export default ContentDrawer;
